// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2147a15","453":"67d974af","455":"6853e89c","977":"edf99913"}[chunkId] + ".chunk.js";
};